import './loadmore.less'

import {m} from '@codeurs/front'
import {t} from 'util/i18n'
import {style} from 'util/style'
import {Theme} from 'views/theme'

export type LoadMoreType = {
	loading: boolean
	loadMore: () => void
}

const styles = style('loadmore')

export const LoadMore: React.FC<LoadMoreType> = ({loading, loadMore}) => {
	return (
		<Theme.PrimaryButton
			as="button"
			class={styles.is({loading})}
			onClick={e => loadMore()}
		>
			{t('library.loadmore')}
		</Theme.PrimaryButton>
	)
}
